import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';

import { reloadForStaleBundleOnce } from './api/stale-bundle';
import { App } from './App';
// `@syncanix/ui` ships design tokens via its `styles.css`. We import it from JS
// rather than via CSS `@import` because Vite's PostCSS pipeline doesn't resolve
// npm-package specifiers in `@import` without the optional `postcss-import`
// plugin (not installed here).
import '@syncanix/ui/styles.css';
import './styles/globals.css';

// Stale-bundle self-heal (F2): when a deploy replaces a hashed lazy chunk, an
// already-open tab's dynamic import 404s and Vite fires `vite:preloadError`.
// Reload once (guarded) to pull the post-deploy bundle rather than leaving the
// route/launcher silently dead. The GraphQL-validation half of the same class
// is handled in the Apollo error link (see api/stale-bundle.ts).
window.addEventListener('vite:preloadError', (event) => {
  event.preventDefault();
  reloadForStaleBundleOnce();
});

const rootEl = document.getElementById('root');
if (!rootEl) {
  throw new Error('Root element #root not found in index.html');
}

createRoot(rootEl).render(
  <StrictMode>
    <App />
  </StrictMode>,
);
